import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames';

const {
  shape
} = PropTypes;

const BBTProTipContainer = (
  {
    metadata = {}
  }
) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  return (
    <div className={classNames(
      'sui-flex sui-justify-center sui-h-full',
      {
        'sui-items-start sui-pt-12': !isMobile,
      }
    )}
    >
      <div className={classNames(
        'sui-proTipCont',
        { 'sui-pt-12': !isMobile }
      )}
      >
        {isMobile ? (
        // Mobile layout: stacked
          (<div className="sui-flex sui-items-center sui-mb-2">
            {/* <div className="sui-mr-3 sui-flex-shrink-0">
              <BBTLogoIcon height="37px" width="32px" color="inverse" />
            </div> */}
            {metadata && (
              <div className="sui-flex-1">
                <Typography variant="h1">{metadata.title}</Typography>
              </div>
            )}
          </div>)
        ) : (
        // Desktop layout: side by side
          (<>
            {/* <div className="sui-mb-2 sui-flex sui-justify-center">
              <BBTLogoIcon height="55px" width="48px" color="inverse" />
            </div> */}
            {metadata && (
              <div className={classNames('sui-pb-3', { 'sui-pt-6': !isMobile })}>
                <Typography variant="h1">{metadata?.title}</Typography>
              </div>
            )}
          </>)
        )}
        <div className={isMobile ? 'sui-mb-2' : 'sui-mb-4 sui-pt-6'}>
          <Typography variant="body-lg" weight="bold">{metadata?.proTip}</Typography>
        </div>
        <div className="sui-pb-2">
          <Typography variant="body-xs">AI-generated using product information on our website.</Typography>
        </div>
      </div>
    </div>
  );
};

BBTProTipContainer.displayName = 'BBTProTipContainer';

BBTProTipContainer.propTypes = {
  metadata: shape({
  })
};

export default BBTProTipContainer;